const params = {
  slidesPerView: 1,
  spaceBetween: 10,
  breakpoints: {
    768: {
      slidesPerView: 2,
      spaceBetween: 20
    },
    1200: {
      slidesPerView: 3,
      spaceBetween: 20
    }
  },
  navigation: {
    nextEl: ".dxp-button-next",
    prevEl: ".dxp-button-prev"
  }
};

export function productBlockCarousel() {
  const swiperElement = document.querySelector(
    ".carousel.products-block swiper-container"
  );

  if (swiperElement) {
    const slideCount = swiperElement.querySelectorAll("swiper-slide").length;
    Object.assign(swiperElement, { ...params, watchOverflow: slideCount <= 3 });
    swiperElement.initialize();
  }
}

export function progressBlockCarousel() {
  const swiperElement = document.querySelector(
    ".carousel.progress-block swiper-container"
  );

  if (swiperElement) {
    const slideCount = swiperElement.querySelectorAll("swiper-slide").length;
    const swiperParams = {
      ...params,
      watchOverflow: slideCount <= 2,
      breakpoints: {
        768: {
          slidesPerView: 3,
          spaceBetween: 30
        }
      }
    };
    Object.assign(swiperElement, swiperParams);
    swiperElement.initialize();
  }
}
